import PlatformMembers from './PlatformMembers';

const TeamManagement = () => {
  return <PlatformMembers />;
};

export default TeamManagement;
